import React from 'react';
import PropTypes, { any } from 'prop-types';
import { useSelector } from 'react-redux';

import PlayerTypeFilter from './Filters/PlayerTypeFilter';
import DivisionFilter from './Filters/DivisionFilter';
import DrawFilter from './Filters/DrawFilter';
import DivisionDateFilter from './Filters/DivisionDateFilter';
import GenderFilter from '../../SearchPage/Filters/GenderFilter';
import DebouncedFilterInput from '../../../components/FormElementsStandalone/DebouncedFilterInput';
import { gameTypeValues, LeagueGenderValues } from '../../../utils/eventConstants';

import styles from '../drawEdit.scss';

const AllPlayersFiltersV3 = (props) => {
    const {
        filters, filterInputs, filterModal, handleFilterClick, handleFilterUpdate, handleFilterSubmit, filteredDivisions, haveFiltersChanged, clearFilters, playerListFilter, updatePlayersListFilter, closeModals,
    } = props;

    const draws = useSelector(({ drawEdit }) => {
        const { draws } = drawEdit;
        return draws?.data;
    });

    const handleGenderUpdate = ({ gender }) => {
        handleFilterUpdate({
            ...(gender === LeagueGenderValues.MIXED ? { playerType: gameTypeValues.DOUBLES } : {}),
            gender,
            selectedDivs: [],
            selectedDraws: [],
            selectedDates: [],
        }, 'submit');
    };

    return (
        <div className={`${styles.section} ${styles.ColorGrey} sub-header`}>
            <div className="row">
                <div className="col-md-9">
                    <div className={styles.filterWrapper}>
                        <PlayerTypeFilter
                            filters={filters}
                            filterInputs={filterInputs}
                            filterModal={filterModal}
                            handleFilterClick={handleFilterClick}
                            handleFilterUpdate={handleFilterUpdate}
                            handleFilterSubmit={handleFilterSubmit}
                            closeModals={closeModals}
                            data-testid="draw-edit.players.filter.player-type"
                        />
                        <GenderFilter
                            filters={filters}
                            filterInputs={filterInputs}
                            filterModal={filterModal}
                            handleFilterClick={handleFilterClick}
                            handleFilterUpdate={handleGenderUpdate}
                            handleFilterSubmit={handleFilterSubmit}
                            showMixedOption={filters.playerType !== gameTypeValues.SINGLES}
                            closeModals={closeModals}
                            data-testid="draw-edit.players.filter.gender"
                        />
                        <DivisionFilter
                            filters={filters}
                            filterInputs={filterInputs}
                            filterModal={filterModal}
                            handleFilterClick={handleFilterClick}
                            handleFilterUpdate={handleFilterUpdate}
                            handleFilterSubmit={handleFilterSubmit}
                            filteredDivisions={filteredDivisions}
                            closeModals={closeModals}
                            data-testid="draw-edit.players.filter.division"
                        />
                        <DivisionDateFilter
                            filters={filters}
                            filterInputs={filterInputs}
                            filterModal={filterModal}
                            handleFilterClick={handleFilterClick}
                            handleFilterUpdate={handleFilterUpdate}
                            handleFilterSubmit={handleFilterSubmit}
                            filteredDivisions={filteredDivisions}
                            closeModals={closeModals}
                            data-testid="draw-edit.players.filter.date"
                        />
                        <DrawFilter
                            filters={filters}
                            filterInputs={filterInputs}
                            filterModal={filterModal}
                            handleFilterClick={handleFilterClick}
                            handleFilterUpdate={handleFilterUpdate}
                            handleFilterSubmit={handleFilterSubmit}
                            draws={draws}
                            closeModals={closeModals}
                            data-testid="draw-edit.players.filter.draw"
                        />
                        {haveFiltersChanged && <span className="clickable text-teal text-small text-normal no-wrap" onClick={clearFilters} data-testid="draw-edit.players.clear-filters-link">Clear</span>}
                    </div>
                </div>
                <div className="col-md-3">
                    <DebouncedFilterInput
                        className={styles.filterInput}
                        divStyle={{ border: '1px solid #A7B2C1', borderRadius: '4px', marginBottom: '5%' }}
                        value={playerListFilter}
                        hideSearchIcon={true}
                        onChange={updatePlayersListFilter}
                        placeholder="Filter players"
                        data-testid="draw-edit.players.filter-input"
                    />
                </div>
            </div>
        </div>
    );
};

AllPlayersFiltersV3.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.objectOf(any).isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    filteredDivisions: PropTypes.arrayOf(any),
    haveFiltersChanged: PropTypes.bool,
    clearFilters: PropTypes.func.isRequired,
    playerListFilter: PropTypes.string,
    updatePlayersListFilter: PropTypes.func.isRequired,
    closeModals: PropTypes.func.isRequired,
};

AllPlayersFiltersV3.defaultProps = {
    haveFiltersChanged: false,
    playerListFilter: '',
    filteredDivisions: [],
};

export default AllPlayersFiltersV3;
